import { render, staticRenderFns } from "./DrawerInsuranceTab.vue?vue&type=template&id=13ae8403&scoped=true"
import script from "./DrawerInsuranceTab.vue?vue&type=script&lang=js"
export * from "./DrawerInsuranceTab.vue?vue&type=script&lang=js"
import style0 from "./DrawerInsuranceTab.vue?vue&type=style&index=0&id=13ae8403&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ae8403",
  null
  
)

export default component.exports